import React from "react";

import { string, func, bool } from "prop-types";

import { TextFieldGroup, Button, Loading } from "../../../../common/index";

const ContactPostcode = ({
  memberPostcode,
  handleChange,
  loading,
  canFindAddress,
  getMatchedAddress,
}) => (
  <div className="form-group">
    <label htmlFor="postcode">Postcode</label>
    <div className="input-group">
      <TextFieldGroup
        classes="register_field form-control"
        value={memberPostcode}
        onChange={(e) => {
          handleChange("postcode", e.target.value);
        }}
        placeholder="e.g. ME14 1AJ"
      />
      <div className="input-group-append">
        <Button
          classes={`m-auto btn btn-block btn-${
            canFindAddress ? "primary" : "colour4 disabled"
          }`}
          onClick={canFindAddress ? getMatchedAddress : () => {}}
        >
          {loading ? <Loading /> : "Find address"}
        </Button>
      </div>
    </div>
  </div>
);

ContactPostcode.propTypes = {
  memberPostcode: string.isRequired,
  handleChange: func.isRequired,
  loading: bool,
  canFindAddress: bool.isRequired,
  getMatchedAddress: func.isRequired,
};

export default ContactPostcode;
